import { inr } from "@/lib/api";

export const ProductPackSelector = ({ packs, selected, onChange, groupId }) => (
  <label className="mt-4 block text-xs font-semibold text-ragi-dark" data-testid={`product-pack-label-${groupId}`}>
    Pack size
    <select value={selected} onChange={(event) => onChange(event.target.value)} className="mt-1.5 h-10 w-full min-w-0 rounded-lg border border-ragi/20 bg-cream-secondary px-3 text-sm font-normal text-ragi-dark transition-colors focus:border-terracotta focus:outline-none" data-testid={`product-pack-select-${groupId}`}>
      {packs.map((pack) => <option key={pack.id} value={pack.id} data-testid={`product-pack-option-${pack.id}`}>{pack.unit} · {pack.sale_mode === "enquiry" ? "Enquire" : inr(pack.price)}</option>)}
    </select>
  </label>
);